module.exports = __webpack_public_path__ + "static/media/pirate-gold-deluxe.bca1936c.gif";